import { render, staticRenderFns } from "./DataRecordsTable.vue?vue&type=template&id=6545add9&scoped=true&"
import script from "./DataRecordsTable.vue?vue&type=script&lang=js&"
export * from "./DataRecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordsTable.vue?vue&type=style&index=0&id=6545add9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6545add9",
  null
  
)

export default component.exports